import { DateFromUntil } from "@/helper/dateHelper";

import hungerApi from "../../api/hunger.api";

import {
  getCurrentGroupSummaryAction,
  getCurrentStoreSummaryAction,
  postToSearchGroupPeriodSummaryAction,
  postToSearchStorePeriodSummaryAction,
} from "./dashboardActions";
import {
  PeriodTotalSummary,
  StorePeriodSummary,
  TotalSummary,
} from "./dashboardTypes";

export const getCurrentGroupSummary =
  (): ThunkActionTypes => async (dispatch) => {
    const { data } = await hungerApi.get<TotalSummary>(
      `/api/v3/mgt/dashboard/groupSummary`
    );
    dispatch(getCurrentGroupSummaryAction(data));
  };

export const getCurrentStoreSummary =
  (storeId: number): ThunkActionTypes =>
  async (dispatch) => {
    const { data } = await hungerApi.get<TotalSummary>(
      `/api/v3/mgt/dashboard/storeSummary/${storeId}`
    );
    dispatch(getCurrentStoreSummaryAction(data));
  };

export const postToSearchGroupPeriodSummary =
  (time: DateFromUntil): ThunkActionTypes =>
  async (dispatch) => {
    const { data } = await hungerApi.post<PeriodTotalSummary>(
      `/api/v3/mgt/dashboard/groupSummary/peroid`,
      { time }
    );
    dispatch(postToSearchGroupPeriodSummaryAction(data));
  };

export const postToSearchStorePeriodSummary =
  (storeId: number, time: DateFromUntil): ThunkActionTypes =>
  async (dispatch) => {
    const { data } = await hungerApi.post<StorePeriodSummary>(
      `/api/v3/mgt/dashboard/storeSummary/${storeId}/peroid`,
      { time }
    );
    dispatch(postToSearchStorePeriodSummaryAction(data));
  };
